import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { useContext } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SAVE_REPORT_UPDATES_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
// @ts-expect-error migrate dependencies
import AsyncSaveReportDialogContainer from 'reporting-action-components/reportingActions/saveReport/dialog/AsyncSaveReportDialogContainer';
// @ts-expect-error migrate dependencies
import SaveReportUpdatesConfirmModal from 'reporting-action-components/reportingActions/saveReportUpdates/dialog/SaveReportUpdatesConfirmModal';

// @ts-expect-error migrate dependencies
import { DialogContext, DialogProvider } from '../dialog/DialogProvider';
// @ts-expect-error migrate dependencies
import { DialogRenderer } from '../dialog/DialogRenderer';
import { EXPORT_REPORT_DIALOG, SAVE_REPORT_DIALOG } from '../dialog/dialogTypes';
import { ErrorBoundary } from '../utils/ErrorBoundary';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { AsyncExportReportModal } from './exportReport/modal/AsyncExportReportModal';
import { ReportingActionsContextProvider } from './ReportingActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportingActionsClient = new DataFetchingClient();
const ReportingActionsLoaderDefaultErrorComponent = () => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actionsLoaderErrorBoundary.message"
    })
  });
};
const DefaultReportingActionsLoaderErrorBoundary = props => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: ReportingActionsLoaderDefaultErrorComponent,
    children: props.children
  });
};
export const ReportingActionsLoader = ({
  additionalDialogs = {},
  children,
  dataFetchingClient,
  tracker,
  ErrorBoundary: ReportingActionsErrorBoundary = DefaultReportingActionsLoaderErrorBoundary
}) => {
  const dialogState = useContext(DialogContext);
  return /*#__PURE__*/_jsx(ReportingActionsErrorBoundary, {
    children: /*#__PURE__*/_jsx(ReportingActionsContextProvider, {
      tracker: tracker,
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: dataFetchingClient || ReportingActionsClient,
        children: dialogState ? children : /*#__PURE__*/_jsxs(DialogProvider, {
          children: [/*#__PURE__*/_jsx(DialogRenderer, {
            dialogTypeToDialog: Object.assign({
              [SAVE_REPORT_DIALOG]: AsyncSaveReportDialogContainer,
              [SAVE_REPORT_UPDATES_DIALOG]: SaveReportUpdatesConfirmModal,
              [EXPORT_REPORT_DIALOG]: AsyncExportReportModal
            }, additionalDialogs)
          }), children, /*#__PURE__*/_jsx(FloatingAlertList, {
            alertStore: ReportActionsFloatingAlertStore
          })]
        })
      })
    })
  });
};
export default ReportingActionsLoader;